import React from 'react'
import styles from './MicrositeFaqSectionForm.module.css'
import TextInput from '../../../components/TextInput/TextInput'
import MicrositeRepeatableRows from '../../../components/MicrositeRepeatableRows/MicrositeRepeatableRows'

const EMPTY_FAQ = { q: '', a: '' }

/**
 * MicrositeFaqSectionForm
 * Content editor for the landing page "FAQ" section.
 *
 * IMPORTANT — different shape from every other landing section:
 * the real saved content for faqSection is a BARE ARRAY of
 * { q, a } pairs, not an object like { heading, faqs: [...] }.
 * There is no heading field at all. `content` here IS the array
 * directly, and `onChange` must be called with a new array, not
 * a merged object — MicrositeLandingSection's parent state is
 * initialized as [] specifically for this sectionKey to match.
 *
 * Pure presentational sub-form — receives `content` (an array) and
 * `onChange` from MicrositeLandingSection, which owns loading/
 * saving/versioning. No DB or API changes required:
 * osm_store_config_landing.content is a generic JSON column already
 * and accepts a JSON array just as readily as a JSON object; this
 * form just sends an array into the same micrositeUpdateLandingSection
 * contract.
 */
const MicrositeFaqSectionForm = ({ content, onChange }) => {
    const faqs = Array.isArray(content) ? content : []

    return (
        <section className={styles.fieldGroup}>
            <h2 className={styles.groupTitle}>FAQ</h2>
            <p className={styles.groupDesc}>Answer common questions before customers have to ask.</p>

            <label className={styles.rowsLabel}>Questions & answers</label>
            <MicrositeRepeatableRows
                items={faqs}
                onChange={(v) => onChange?.(v)}
                emptyItem={{ ...EMPTY_FAQ }}
                addLabel="Add FAQ"
                renderSummary={(item) => item.q || 'New question'}
                renderItem={(item, idx, updateItem) => (
                    <div className={styles.faqFields}>
                        <TextInput
                            label="Question"
                            value={item.q}
                            onChange={(v) => updateItem('q', v)}
                            placeholder="e.g. Do I need to book an appointment in advance?"
                        />
                        <label className={styles.textareaLabel}>Answer</label>
                        <textarea
                            className={styles.textarea}
                            rows={3}
                            value={item.a || ''}
                            onChange={(e) => updateItem('a', e.target.value)}
                            placeholder="Give a clear, helpful answer"
                        />
                    </div>
                )}
            />
        </section>
    )
}

export default MicrositeFaqSectionForm